export default "__VITE_ASSET__0512e3c9__"